import { CSSObject } from '@emotion/react';

export const buttonIncreaseProps: CSSObject = {
  variant: 'odds',
  fontWeight: 'black',
  fontFamily: 'Roboto',
  borderRadius: 'base',
};

export const IncreaseAmountWrapper: CSSObject = {
  gap: '1',
};
